import { motion } from "framer-motion";

export function PlatformPreview() {
  const images = [
    {
      src: "/scr1.png",
      alt: "Screenshot of the Material Stock overview in the Sentiri platform",
      title: "Material Stock Overview"
    },
    {
      src: "/scr2.png",
      alt: "Screenshot of the Real-Time AI Insights in the Sentiri platform",
      title: "Real-Time AI Insights"
    }
  ];

  return (
    <div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          className="text-center mb-8 sm:mb-12 md:mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold relative mb-2 sm:mb-4 pb-1 leading-tight">
            <div className="absolute -inset-1 bg-gradient-to-r from-[#00DC82]/20 to-transparent blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <span className="text-foreground">A Glimpse Into </span>
            <span className="text-[#00DC82]">the Platform</span>
          </h2>
          <div className="flex justify-center">
            <p className="text-base sm:text-lg md:text-xl leading-relaxed tracking-tight text-muted-foreground max-w-4xl text-center mt-2 md:mt-4 lg:mt-6">
              Explore how Sentiri provides clarity and control over your material inventory and carbon footprint, turning complex data into actionable insights.
            </p>
          </div>
        </motion.div>
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          {images.map((image, index) => (
            <motion.div
              key={index}
              className="group relative rounded-xl overflow-hidden shadow-lg hover:shadow-2xl hover:shadow-[#00DC82]/30 transition-all duration-500 transform hover:-translate-y-1 border-2 border-[#00DC82]/20 hover:border-[#00DC82]"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <img
                src={image.src}
                alt={image.alt}
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-black/0 to-transparent dark:from-black/20 dark:via-black/5" />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
} 